import {  PolylineEdge, PolylineEdgeModel, h } from "@logicflow/core";

class CustomEdgeModel extends PolylineEdgeModel {
    // customTextPosition = true;
    initEdgeData(data) {
        super.initEdgeData(data);
        this.customTextPosition = true;
    }
    setAttributes() {
        this.isAnimation = true;
    }
    setHovered(isHovered) {
        // super.setHovered(isHovered);
        // this.isAnimation = isHovered;
    }
    getEdgeAnimationStyle() {
        const style = super.getEdgeAnimationStyle();
        style.stroke="rgb(24, 125, 255)";
        style.strokeDasharray = "10 10";
        style.strokeDashoffset = "100%";
        style.animationDuration = "50s";
        return style;
    }

    getTextPosition() {
        const position = super.getTextPosition();
        const currentPositionList = this.points.split(" ");
        const pointsList = [];
        currentPositionList &&
        currentPositionList.forEach((item) => {
            const [x, y] = item.split(",");
            pointsList.push({ x: Number(x), y: Number(y) });
        });
        if (pointsList.length > 1) {
            let { x: x1, y: y1 } = pointsList[0];
            let { x: x2, y: y2 } = pointsList[1];
            let distence = 50;
            // 垂直
            if (x1 === x2) {
                if (y2 < y1) {
                    // 上
                    distence = -50;
                }
                position.y = y1 + distence;
                position.x = x1;
            } else {
                // 水平
                if (x2 < x1) {
                    // 左
                    distence = -50;
                }
                position.x = x1 + distence;
                position.y = y1 - 10;
            }
        }
        return position;
    }
}

class CustomEdge extends PolylineEdge {
    getEndArrow() {
        const { stroke } = this.props.model.getArrowStyle();
        return h("path", {
            stroke,
            fill: "rgb(24, 125, 255)",
            d: "M 0 0 -10 -5 -10 5 z"
        });
    }
}

export default {
    type: "custom-edge",
    model: CustomEdgeModel,
    view: CustomEdge
};
